module.exports = __webpack_public_path__ + "img/lifecycle.41afd0be.png";